import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFVideo from '@/components/UI/EFVideo';
import EcoImg from 'eco-design/base/eco-img';
import { useLang } from '@/app/utils/useLang';

type TabType = {
    title: string;
    desc: string;
    img_title: string;
    img_desc: string;
    pc: string;
    h5: string;
};

export default function F() {
    const { useEffect, useState } = useGlobal();
    const { t } = useLang('wholehomeF');
    const [enter, setEnter] = useState(false);

    useEffect(() => {
        const winH = typeof window !== 'undefined' ? window.innerHeight : 1080;
        AniContainer.create({
            triggerElement: '.whole-home-F',
            triggerHook: 1,
            offset: winH * 0.5 + 112,
            duration: winH * 1.5,
            onEnter: () => {
                setEnter(true);
            },
            onLeave: () => {
                setEnter(false);
            },
        });
    }, []);

    const [fixH, setFixH] = useState(0);
    const [activeTab, setActiveTab] = useState(0);
    const tabs: TabType[] = [
        {
            title: t('tab1_title'),
            desc: t('tab1_desc'),
            img_title: t('img1_title'),
            img_desc: t('img1_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1747898993267/shp-%E8%A7%86%E9%A2%91%E9%9D%99%E5%B8%A7%E5%9B%BE%E5%A4%87%E4%BB%BD.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1747900855965/DPU%2BSHP2_Nightfall%20House%202%20(1)%20(1).jpg',
        },
        {
            title: t('tab2_title'),
            desc: t('tab2_desc'),
            img_title: t('img2_title'),
            img_desc: t('img2_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1747992592801/shp-%E8%A7%86%E9%A2%91%E9%9D%99%E5%B8%A7%E5%9B%BE%E5%A4%87%E4%BB%BD2.5x%20(2).jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1747992766227/DSC02782%20-%20%E6%97%8B%E8%BD%AC%E6%B0%B4%E5%B9%B3%201%20(1).png',
        },
    ];
    const hanldeClickTab = (k: number) => {
        setActiveTab(k);
    };

    return (
        <div id="whole-home-F" className={`whole-home-F ${css['whole-home-F']}`}>
            <div className="fix-sub-header" style={{ top: `${fixH}px` }}>
                <ul className="header-tabs">
                    {tabs?.map((tab: TabType, k: number) => (
                        <a
                            href={k === 0 ? '#whole-home-G-section-2' : '#whole-home-G-section-3'}
                            className={`tab-item ${activeTab === k ? 'active' : ''}`}
                            key={tab.title}
                            onClick={() => hanldeClickTab(k)}
                        >
                            <p className="tab-title">{tab.title}</p>
                            <p className="tab-desc">{tab.desc}</p>
                        </a>
                    ))}
                </ul>
            </div>
            <div className={`secF-sticky ${enter ? 'enter' : ''}`}>
                <section className="section-box">
                    <div className="text-box">
                        <p className="title">{tabs[activeTab].img_title}</p>
                        <p className="desc">{tabs[activeTab].img_desc}</p>
                    </div>
                </section>
                <section className="video-box">
                    <EcoImg pc={tabs[activeTab].pc} pad={tabs[activeTab].h5} h5={tabs[activeTab].h5} />
                </section>
            </div>
        </div>
    );
}
